module.exports = "/fonts/opensansbold.ttf";